import useTranslation from "@/hooks/useTranslation";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import React from "react";
import CartList from "./components/CartList";

interface IProps {
  menuOpen: boolean;
  handleMenuClose: () => void;
}

const AddList: React.FC<IProps> = ({ menuOpen, handleMenuClose }) => {
  const { t } = useTranslation("bundle");

  return (
    <>
      <Dialog
        onClose={handleMenuClose}
        open={menuOpen}
        scroll="paper"
        fullWidth
      >
        <DialogTitle>{t("cart.add.to-collection")}</DialogTitle>
        <CartList handleUpperClose={handleMenuClose} />
      </Dialog>
    </>
  );
};

export default AddList;
